import { render, staticRenderFns } from "./transaction-types.vue?vue&type=template&id=59a398f1&"
import script from "./transaction-types.vue?vue&type=script&lang=js&"
export * from "./transaction-types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports